<template>
  <div>
    <List>
      <input-focus inputType="text" v-model="email">
        {{ $l['userEmail'] }}
      </input-focus>

      <input-focus
        inputType="text"
        v-model="password"
        :placeholder="$l.ifChangePassword"
        >
        {{ $l['userPassword'] }}
      </input-focus>

      <button-save :action="save">
        {{ $l.save }}
      </button-save>
    </List>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import MixinLocale from '@/components/MixinLocale'
import List from '@/components/List'
import InputFocus from '@/components/InputFocus'
import ButtonSave from '@/components/Button'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    List,
    InputFocus,
    ButtonSave
  },

  created: function () {
    this.setPassword('')
  },

  computed: {
    email: {
      get: function () {
        return this.$store.state.user.email
      },
      set: function (email) {
        this.setEmail(email)
      }
    },

    password: {
      get: function () {
        return this.$store.state.user.password
      },
      set: function (password) {
        this.setPassword(password)
      }
    }
  },

  methods: {
    ...mapMutations('user', [
      'setEmail',
      'setPassword'
    ]),

    save: function () {
      if (window.confirm(this.$l['loginInfoConfirm'])) {
        this.$router.go(-1)
        this.$store.dispatch('user/saveLoginInfo')
      }
    }
  }
}
</script>
